(function () {
  let BrightcoveVideo = {
    init: function () {
      this.hideContentBelowVideo()
    },

    hideContentBelowVideo() {
      const brightcoveContainerElement = document.querySelector('.brightcove-video-main-wrapper')
      const sectionElement = document.querySelector(`#${brightcoveContainerElement.dataset.sectionId}`)
      const hideContentBelowVideo = (brightcoveContainerElement.dataset.hideContentBelowVideo === 'true');
      let hideContentBelowVideoFor = brightcoveContainerElement.dataset.hideContentBelowVideoFor
      hideContentBelowVideoFor = !isNaN(hideContentBelowVideoFor) ? parseInt(hideContentBelowVideoFor) : 764

      // hide all content below the video
      if (hideContentBelowVideo) {
        this.hideAllSiblings(sectionElement.nextSibling);
      }

      // set a timeout to unhide all content after the specified time
      setTimeout(
        () => {
          this.unhideAllSiblings(sectionElement.nextSibling);
        },
        hideContentBelowVideoFor * 1000
      )
    },

    async hideAllSiblings(element) {
      // element maybe be null
      if (element) {
        // check for valid node type before proceeding
        if (element.nodeType !== 3) {
          const exemptFromHiding = element.querySelector("[data-exempt-from-hiding='true']")
          if (!exemptFromHiding) {
            await element.classList.add('hide-temporarily')
          }
        }

        // recursively process next node
        this.hideAllSiblings(element.nextSibling)
      }
    },

    async unhideAllSiblings(element) {
      // element maybe be null
      if (element) {
        // check for valid node type before proceeding
        if (element.nodeType !== 3) {
          await element.classList.remove('hide-temporarily')
        }

        // recursively process next node
        this.unhideAllSiblings(element.nextSibling)
        element.style.setProperty("display", "block", "important"); 

      }
    },
  }

  window.addEventListener('load', (event) => {
    BrightcoveVideo.init()
  })

})()
